import ServiceList from ".";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ServiceCategory from "../ServiceCategory";
import ServiceTags from "../ServiceTags";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-brands fa-servicestack",
    path: "/admin/services",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/services-categories",
  },
  {
    label: "Tags",
    icon: "fa-regular fa-tags",
    path: "/admin/services-tags",
  },
];

export const serviceRoutes = () => [
  {
    path: "/admin/services",
    title: "Service Management",
    layout: "admin",
    routeType: "admin",
    component: () => (
      <TabsNavigation title="Service Management" tabRoutes={tabRoutes}>
        <ServiceList />
      </TabsNavigation>
    ),
  },
  {
    path: "/admin/services-categories",
    title: "Service Management",
    layout: "admin",
    routeType: "admin",
    component: () => (
      <TabsNavigation title="Service Management" tabRoutes={tabRoutes}>
        <ServiceCategory />
      </TabsNavigation>
    ),
  },
  {
    path: "/admin/services-tags",
    title: "Service Management",
    layout: "admin",
    routeType: "admin",
    component: () => (
      <TabsNavigation title="Service Management" tabRoutes={tabRoutes}>
        <ServiceTags />
      </TabsNavigation>
    ),
  },
];
